/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreBank131PayWithRecurrentRequest
 */
export interface FxIdWebFeaturesStoreBank131PayWithRecurrentRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreBank131PayWithRecurrentRequest
     */
    PublicId: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithRecurrentRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithRecurrentRequest(value: object): value is FxIdWebFeaturesStoreBank131PayWithRecurrentRequest {
    if (!('PublicId' in value) || value['PublicId'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSON(json: any): FxIdWebFeaturesStoreBank131PayWithRecurrentRequest {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreBank131PayWithRecurrentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'PublicId': json['PublicId'],
    };
}

export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSON(json: any): FxIdWebFeaturesStoreBank131PayWithRecurrentRequest {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSONTyped(value?: FxIdWebFeaturesStoreBank131PayWithRecurrentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PublicId': value['PublicId'],
    };
}

